export default __webpack_public_path__ + "static/media/arrow-down-purple-2.669e6667.svg";